<template>
  <FormContainer>
    <template #title>Adresse du lieu de formation</template>
    <template #content>
      <div class="form__bloc">
        <BasicCheckbox
          v-if="metaModuleEnCours?.lieuFormationIdentiqueCfaPrincipal?.$status !== PropertyStatus.NotPresent"
          id="field_26"
          :model-value="moduleEnCours?.lieuFormationIdentiqueCfaPrincipal"
          @update:model-value="(value) => setAdresseIdentiqueCfaPrincipal(value!)"
          label="La formation a lieu à l'adresse de l'organisme de formation"
          class="col-36"
          :readonly
        />
        <!-- Plus besoin de ce cas-->
        <BasicCheckbox
          v-else
          id="field_66"
          label="La formation a lieu à l'adresse de l'organisme de formation"
          class="col-36"
          disabled
        />
      </div>
      <div
        class="form__bloc"
        v-if="metaModuleEnCours?.lieuFormation?.$status !== PropertyStatus.NotPresent"
      >
        <WrapperInput
          id="field_27 field_67"
          label="N° et libellé de la voie (adresse)"
          class="col-12 col-md-18 col-sm-36"
          @update:model-value="(value: any) => updateModule('lieuFormation.voie', activeModuleIndex!, value)"
          :model-value="moduleEnCours?.lieuFormation?.voie"
          :required="metaModuleEnCours?.lieuFormation?.voie?.$status === PropertyStatus.Required"
          :alertLabel="
            metaModuleEnCours?.lieuFormation?.voie?.$messageErreurDirty ??
            metaModuleEnCours?.lieuFormation?.$messageErreurDirty! ??
            ''
          "
          :maxlength="38"
          :readonly
          deletable
        />
        <WrapperInput
          id="field_unknown"
          :model-value="moduleEnCours?.lieuFormation?.complement"
          @update:model-value="(value: any) => updateModule('lieuFormation.complement', activeModuleIndex!, value)"
          label="Complément d'adresse"
          class="col-12 col-md-18 col-sm-36"
          :required="
            metaModuleEnCours?.etablissementPrestataire?.adresse?.complement?.$status === PropertyStatus.Required
          "
          :alertLabel="metaModuleEnCours?.etablissementPrestataire?.adresse?.complement?.$messageErreurDirty!"
          :maxlength="38"
          :readonly
          deletable
        />
        <WrapperInput
          id="field_28 field_68"
          :model-value="moduleEnCours?.lieuFormation?.codePostal"
          @update:model-value="(value: any) => updateModule('lieuFormation.codePostal', activeModuleIndex!, value)"
          label="Code postal"
          class="col-4 col-md-6 col-sm-36"
          :required="metaModuleEnCours?.lieuFormation?.codePostal?.$status === PropertyStatus.Required"
          :alertLabel="
            metaModuleEnCours?.lieuFormation?.codePostal?.$messageErreurDirty ??
            metaModuleEnCours?.lieuFormation?.$messageErreurDirty! ??
            ''
          "
          :maxlength="5"
          :readonly
          deletable
        />
        <WrapperInput
          id="field_29 field_69"
          :model-value="moduleEnCours?.lieuFormation?.commune"
          @update:model-value="(value: any) => updateModule('lieuFormation.commune', activeModuleIndex!, value)"
          label="Ville"
          class="col-8 col-md-12 col-sm-36"
          :required="metaModuleEnCours?.lieuFormation?.commune?.$status === PropertyStatus.Required"
          :alertLabel="
            metaModuleEnCours?.lieuFormation?.commune?.$messageErreurDirty ??
            metaModuleEnCours?.lieuFormation?.$messageErreurDirty! ??
            ''
          "
          :maxlength="50"
          :readonly
          deletable
        />
      </div>
      <div
        v-else
        class="form__bloc"
      >
        <WrapperInput
          id="field_27 field_67"
          label="N° et libellé de la voie (adresse)"
          class="col-12 col-md-18 col-sm-36"
          :maxlength="38"
          disabled
        />
        <WrapperInput
          id="field_21"
          label="Complément d'adresse"
          class="col-12 col-md-18 col-sm-36"
          :maxlength="38"
          disabled
        />
        <WrapperInput
          id="field_28 field_68"
          label="Code postal"
          class="col-4 col-md-6 col-sm-36"
          :maxlength="5"
          disabled
        />
        <WrapperInput
          id="field_29 field_69"
          label="Ville"
          class="col-8 col-md-12 col-sm-36"
          :maxlength="50"
          disabled
        />
      </div>
    </template>
  </FormContainer>
</template>

<script setup lang="ts">
  import type { ModuleDTO } from '@/features/api/extranet/dto/Demande/CXPI'
import { PropertyStatus } from '@/features/domaine/property-status/PropertyStatus.ts'
import { CXPI_MODULES_ACTIONS } from '@/features/interface/demande/cxpi/steps/formation/useModuleActions.ts'
import { DEMANDE_STORE, FormContainer } from '@/features/interface/demande/shared'
import { storeToRefs } from 'pinia'
import { inject } from 'vue'

  const store = inject(DEMANDE_STORE)!.getStore('MODEL_CXPI')
  const { setupArrayUpdaterWithKey } = store

  const { moduleEnCours, activeModuleIndex, metaModuleEnCours, setAdresseIdentiqueCfaPrincipal } =
    inject(CXPI_MODULES_ACTIONS)!

  const { readonly } = storeToRefs(store)

  const updateModule = setupArrayUpdaterWithKey<ModuleDTO>('formation.modules')
</script>
